import { render, staticRenderFns } from "./jobfairPostdetail.vue?vue&type=template&id=0775977e&scoped=true"
import script from "./jobfairPostdetail.vue?vue&type=script&lang=js"
export * from "./jobfairPostdetail.vue?vue&type=script&lang=js"
import style0 from "./jobfairPostdetail.vue?vue&type=style&index=0&id=0775977e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0775977e",
  null
  
)

export default component.exports